<template>
    <v-timeline
        class="comments-timeline"
        dense
        align-top
    >
        <v-timeline-item
            v-for="item in comments"
            :key="item.id"
            :icon="item.type | iconByType"
            right
        >
            <template slot="opposite">
                <div class="mt-2">
                    <span class="grey--text text--darken-2">{{ item.createdAt | formatDate('MMM DD') }}</span><br>
                    {{ item.createdAt | formatDate('h:mma') }}
                </div>
            </template>
            <div class="mt-2">
                <span
                    v-if="item.title"
                    class="font-weight-bold"
                >
                    {{ item.title }}
                </span>
                <p
                    v-if="item.body"
                    class="text-body"
                >{{ item.body }}</p>
            </div>
        </v-timeline-item>
        <v-timeline-item v-if="!disabled">
            <template slot="opposite">
                <!-- empty slot so content is aligned properly -->
                <div />
            </template>
            <v-form
                ref="commentForm"
                @submit.prevent="onSubmit"
            >
                <v-textarea
                    label="Message"
                    v-model="newComment"
                    :rules="[rules.required]"
                />
                <v-btn
                    type="submit"
                    color="primary"
                >
                    Submit
                </v-btn>
            </v-form>
        </v-timeline-item>
    </v-timeline>
</template>

<script>
import axios from 'axios'
import { statuses } from '../utils/constants/statuses'
import SnackBus from '../utils/buses/snackBus'
import UserBus from '../utils/buses/userBus'
import { defaultError422, requestErrorMessage } from '../utils/constants/errors'

export default {
    props: {
        comments: {
            type: Array,
            required: true
        },
        returnId: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            newComment: null,
            rules: {
                required: value => !!value || 'This field is required'
            },
            isSubmitting: false
        }
    },
    filters: {
        iconByType: function (value) {
            return value && statuses[value] && statuses[value].icon
                ? statuses[value].icon
                : null
        }
    },
    methods: {
        onSubmit () {
            if (!this.$refs.commentForm.validate()) {
                SnackBus.showMessage(defaultError422, 'error')
                return
            }
            this.isSubmitting = true
            const formData = new FormData()
            formData.set('comment', this.newComment)
            formData.set('token', UserBus.token)

            axios.post('/api/returns/' + this.returnId + '/comment', formData)
                .then(res => {
                    // reset comment field
                    this.newComment = null
                    if (this.$refs.commentForm) {
                        this.$refs.commentForm.resetValidation()
                    }
                    this.$emit('refresh-data', true)
                })
                .catch(err => {
                    console.log('Post Comment Error', err)
                    SnackBus.showMessage(requestErrorMessage, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.comments-timeline {
    /deep/ .v-timeline-item__opposite {
        display: inline-block;
        min-width: 55px;
        align-self: flex-start;
    }

    &.v-timeline--dense:before {
        left: 102px;
    }

    &.v-timeline--dense /deep/ .v-timeline-item__dot {
        left: 83px;
    }

    /deep/ .v-timeline-item__inner-dot i {
        font-size: 16px;
    }
}
.text-body {
    white-space: pre-line;
}
</style>
